import { render, staticRenderFns } from "./EntityEdit.vue?vue&type=template&id=473ad162"
import script from "./EntityEdit.vue?vue&type=script&lang=ts"
export * from "./EntityEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports